export enum PaymentMethods {
  PAYSTACK = "PAYSTACK",
  FLUTTERWAVE = "FLUTTERWAVE",
  CASH = "CASH",
  WALLET = "WALLET",
}
